import { createSelector } from 'reselect'

import { TBasicInfoCreated } from '../models/partnerBasicInfo'

import { selectBasicInfoState } from './selectBasicInfoState'

export const selectCreatedBasicInfo = createSelector(
  [selectBasicInfoState],
  ({ createdData }) => createdData as TBasicInfoCreated
)
